// extracted by mini-css-extract-plugin
module.exports = {"overlayMenuItem":"OverlayMenuItem_overlayMenuItem__vtU7O"};